export default {
    'create-status': 'إنشاء حالة',
    headers: {
        name: 'الاسم',
        'invoice-type': 'نوع الفاتورة',
        'is-final-status': 'تمثل الحالة النهائية'
    },
    'create-delivery-status' : 'إنشاء حالة تسليم',
    'edit-delivery-status' : 'تعديل حالة تسليم',

    delete: {
        'delete-delivery-status': 'حذف حالة تسليم',
        'delete-dialog-content': 'هل أنت متاكد من حذف حالة التسليم هذه ؟',
    },

    inputs: {
        'delivery-name': 'اسم الحالة',
        'invoice-type': 'نوع الفاتورة',
        'final-status': 'تعيين كحالة نهائية'
    },

    chips: {
        true: 'نعم',
        false: 'لا'
    },

    buttons: {
        add: 'إضافة',
        edit: 'تعديل',
        delete: 'حذف',
        cancel: 'إلغاء'
    }
}